import Stack from '@blueshift-ui/core/dist/components/stack';
import { TrackedButton } from '@blueshift-ui/analytics';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

interface UpdateMembershipStep1Props {
  isContract: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function UpdateMembershipStep1({ isContract, onClick }: UpdateMembershipStep1Props) {
  const { loading: loadingRichTranslation, translate: richTranslate } = useTranslation(
    'update.membership.options',
    { rich: true }
  );
  const { loading: loadingTranslation, translate } = useTranslation('update.membership.options');

  if (loadingTranslation || loadingRichTranslation) {
    return null;
  }

  return (
    <>
      <Stack direction={{ xs: 'column', sm: 'row' }}>
        <TrackedButton
          color="secondary"
          id="update_membership_button"
          onClick={onClick}
          variant="outlined"
        >
          {translate('adjust_button_name')}
        </TrackedButton>
      </Stack>
    </>
  );
}

export default UpdateMembershipStep1;
